import { ACCESS_TOKEN } from '../constants/index';
var soap = require('../local_node_modules/soap-everywhere/index');

class SoapService {

  constructor(wsdlAdress, onErrorOccured) {
    this.client = null;
    this.wsdlAdress = wsdlAdress;
    this.onErrorOccured = onErrorOccured;
    this.invoke = this.invoke.bind(this);
  }

  invoke(method, args, callback) {

    if (this.client) {

      this.invokeStep2(method, args, callback);

    } else {
      
      soap.createClient(this.wsdlAdress, {}, (err, client) => {

        if (err) {

          let errObj = {errorCode: "WEB_SERVICE_CONNECTION_ERROR", errorMessage: "Web servis bağlantı hatası"};

          if (this.onErrorOccured) {
            this.onErrorOccured(errObj);
          }

          callback(true, err);

        } else {

          client.security = new soap.BearerAuthSecurity(localStorage.getItem(ACCESS_TOKEN));
    
          this.client = client;
    
          this.invokeStep2(method, args, callback);    
        }
      });
    }
  }

  invokeStep2(method, args, callback) {

    this.client[method](args, (error, result, raw) => {

      if (error) {

        let errorMessage = result && result.detail && result.detail.serviceFault && result.detail.serviceFault.message;
        let errorCode = result && result.detail && result.detail.serviceFault && (result.detail.serviceFault.code || result.detail.serviceFault.errorCode);

        if (!errorMessage)
          errorMessage = result && result.Detail && result.Detail.serviceFault && result.Detail.serviceFault.message;

        if (!errorCode)
          errorCode = result && result.Detail && result.Detail.serviceFault && (result.Detail.serviceFault.code || result.Detail.serviceFault.errorCode);

        if (!errorCode)
          errorCode = "UNKNOWN_ERROR";
        
        if (!errorMessage)
          errorMessage = errorCode || "Bilinmeyen hata";

        let errorObj = {errorCode: errorCode, errorMessage: errorMessage};

        if (this.onErrorOccured) {
          this.onErrorOccured(errorObj);
        }
        
        callback(true, errorObj);

      } else {

        callback(false, result);
      }

    });
  }

  promise(method, args) {
    return new Promise((resolve, reject) => {
      this.invoke(method, args, (error, result) => {
        if (error) {
          reject(result);
        } else {
          resolve(result);
        }
      })
    });
  }
}

export default SoapService;
